window.getCookie = (name) => {
  return (document.cookie.match(`(^|; )${name}=([^;]*)`) || 0)[2];
};

window.setCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${
    value || ""
  }${expires}; path=/`;
};

window.deleteCookie = (name) => {
  document.cookie = `${name}=''; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
};

window.getQueryParam = (name) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
};
